/** @type {import('../lib/dataTable').DataTableColumn[]} */
export const STACK_COLUMNS = [
  { id: "stack_id", label: "Stack", accessorKey: "stack_id", filterType: "text" },
  { id: "variety", label: "Variety", accessorKey: "variety", filterType: "text" },
  { id: "current_qtl", label: "Current (qtl)", accessorKey: "current_qtl", filterType: "text" },
  { id: "capacity_qtl", label: "Capacity", accessorKey: "capacity_qtl", filterType: "text" },
  { id: "age_days", label: "Age", accessorKey: "age_days", filterType: "text" },
];
